import dayjs from 'dayjs';

/**
 * Calculate the time elapsed since the start time in seconds
 * @param startedAt - the start time (ISO string or Date)
 * @returns seconds elapsed
 */
export default function timeElapse(startedAt: string | Date): number {
  const startedAtDate = dayjs(startedAt);
  const now = dayjs();
  return now.diff(startedAtDate, 'second');
}
